import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import BuffItem from '../buffItem/BuffItem';
import { useFilteredBuffs } from '../../../../hooks/shared/buffs/useFilteredBuffs';

const Buffs = React.forwardRef(function ({ className }, ref) {
  const filteredBuffs = useFilteredBuffs();

  return (
    !!filteredBuffs?.length && (
      <div
        className={classNames('friends-buffs', className, {
          [`friends-buffs_max-${filteredBuffs?.length}`]: filteredBuffs?.length,
        })}
      >
        <Swiper watchOverflow={true} slidesPerView={'auto'}>
          {filteredBuffs?.map((buffData, index) => (
            <SwiperSlide>
              <BuffItem key={index} buffData={buffData} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )
  );
});

export default Buffs;
Buffs.propTypes = {};
